import { logFactory, components, vendors, isCompExists } from "GlobalSite";
import {
  LABELS_GOAL,
  LABELS_PROFIL,
  LABELS_ENVELOP,
  LABELS_ASSET,
  COLORS,
  PATRIMONY_STEPS,
  MyProposalAllocations,
  MyProposalManagementMethods,
} from "./constantes.mjs";

const {
  jquery: { $ },
} = vendors;

const compName = "comp_aem_proposal-form";
const Log = logFactory(compName);
const { log } = Log;
log("--->");

const {
  compTechRanges: { initRange },
  compTechDonutChart: { createDonutChart },
} = components;

function formatAmount(v) {
  const currency = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumSignificantDigits: 2,
  });
  return v >= 5000000 ? `${currency.format(v)}+` : currency.format(v);
}

// Fonction pour obtenir l'allocation selon les critères
function getAllocation(profil, hasRetirement, patrimony) {
  const isPlus500k = patrimony >= 500000;

  return (
    MyProposalAllocations[profil]?.[hasRetirement]?.[isPlus500k] ||
    MyProposalAllocations?.equilibre?.false?.true
  );
}

function tableRow(env, data, i, assets) {
  const showRow = data.montant > 0 || env !== "per";
  const cellClass = (pct) => (pct > 0 ? "" : "opacity-30");
  let rowHTML = [];

  if (showRow) {
    rowHTML.push(`<tr>`);
    rowHTML.push(
      `<th id="row${i}" scope="row">${LABELS_ENVELOP[env]}<br><span>${formatAmount(data.montant)}</span></th>`,
    );

    let cells = Object.entries(data);

    if (env === "epargne") {
      for (let j = 0; j < 5; j++) {
        rowHTML.push(`<td class="table__empty" headers="row${i} col${j}">
            <span class="sr-only">Pas de données</span>
            <span aria-hidden="true">-</span>
          </td>`);
      }
    } else {
      cells.forEach((elem, index) => {
        const [key, val] = elem;

        if (key !== "pct" && key !== "montant") {
          let keyPercent = Math.round((data.montant * data[key]) / 100);
          assets[key] += keyPercent;
          rowHTML.push(
            `<td  headers="row${i} col${index}" ${cellClass(val)}><span>${val}%</span></td>`,
          );
        }
      });
    }
    rowHTML.push(`</tr>`);
  }
  rowHTML.join("");
  return rowHTML;
}

function makeTable(envelopes, assets, distribution) {
  const res = [];
  let index = 1;

  // Creation du tableau
  for (const [key, value] of Object.entries(envelopes)) {
    const rowHTML = tableRow(key, value, index, assets);

    res.push(rowHTML);
    index++;
  }

  const totalByAsset = Object.values(assets).reduce((sum, val) => sum + val, 0);

  let totalRow = `<tr><th id="row${index + 1}"  scope="row">Total</th>`;

  // ligne des totaux
  Object.entries(assets).forEach((elem, k) => {
    const [key, val] = elem;
    let pct =
      totalByAsset > 0 ? Math.round((assets[key] / totalByAsset) * 100) : 0;

    distribution[key] = pct;

    totalRow += `<td headers="row${index + 1} col${k + 2}">
           <div class="table__result"> ${pct}%<div class="table__arrow"></div>${formatAmount(val)}</div>
         </td>`;
  });

  totalRow += `</tr>`;
  res.push(totalRow);
  return res;
}

function calculateAmountByEnvelopes(patrimony, allocation) {
  // Liste des catégories
  const envelopesTypes = Object.keys(allocation);

  const envelopes = {};

  // Calcul pour les envelopes standard
  envelopesTypes.forEach((type) => {
    envelopes[type] = {
      montant: Math.round((patrimony * allocation[type].pct) / 100),
      ...allocation[type],
    };
  });

  return envelopes;
}

function calcDistributionWithoutSaving(envelopes) {
  let distrib = [];
  let legend = [];
  const types = Object.keys(envelopes).filter((t) => t !== "epargne");

  const total = types.reduce((sum, env) => sum + envelopes[env].montant, 0);

  types.forEach((t) => {
    const data = envelopes[t];
    if (data.montant > 0) {
      const pct = total > 0 ? Math.round((data.montant / total) * 100) : 0;
      distrib.push(pct);
      legend.push(LABELS_ENVELOP[t]);
    }
  });

  return { distrib, legend };
}
const calcDistributionByAsset = (assets) =>
  Object.entries(assets).filter(([, val]) => val > 0);

function formatResult(formData) {
  const patrimonyOutput = formatAmount(
    PATRIMONY_STEPS[parseInt(formData.get("patrimony"), 10)],
  );
  const objectivesOutput = formData.getAll("objectives").map((elem) => {
    return LABELS_GOAL[elem];
  });

  const results = {
    patrimony: patrimonyOutput,
    objectives: objectivesOutput.join("<br>"),
    profil: LABELS_PROFIL[formData.get("profil")],
    horizon: formData.get("horizon") + " ans",
  };

  return results;
}

$(function domReady() {
  const $context = $(`._${compName}`);
  const $form = $("#myProposal");
  let formData;

  if (!isCompExists(compName, Log)) {
    return;
  }

  // ===== Ranges =====

  initRange({
    range: "#range-patrimony",
    output: "#range-output-patrimony",
    values: PATRIMONY_STEPS,
    format: (v) => formatAmount(v),
  });

  initRange({
    range: "#range-horizon",
    output: "#info-horizon .ranges__button",
    format: (v) => v + " ans",
  });

  function validateStep(step) {
    formData = new FormData($form[0]);
    const requiredFields = {
      1: "objectives",
      2: "profil",
      3: "knowledge",
    };

    return requiredFields[step] ? formData.has(requiredFields[step]) : true;
  }

  // ===== STEP NAVIGATION =====
  let currentStep = 1;
  const totalSteps = 4;
  const $btnNext = $form.find(".form-default__prev-next .cta-secondary");
  const $btnPrev = $form.find(".form-default__prev-next .cta-border-primary");
  const $error = $form.find(".error");
  const $formSteps = $context.find("[class^='form-step']");
  const $stepper = $(".stepper__steps");
  const $steps = $stepper.find("li");

  function showStep(stepNumber) {
    $formSteps.addClass("is-hidden");
    $context.find(`.form-step${stepNumber}`).removeClass("is-hidden");
    updateStepper(stepNumber);

    // Gestion simplifiée de la visibilité
    $btnPrev.toggleClass("is-hidden", stepNumber === 1);
    $btnNext.toggleClass("is-hidden", stepNumber === totalSteps);

    if (stepNumber === totalSteps) {
      showResults();
    }
  }

  function updateStepper(stepNumber) {
    $stepper.find("[aria-current='step']").removeAttr("aria-current");
    $($steps.eq(stepNumber - 1)).attr("aria-current", "step");
  }

  $form.on("click", ".form-default__prev-next .cta-secondary", function () {
    if (validateStep(currentStep)) {
      if (currentStep < totalSteps) {
        currentStep++;
        showStep(currentStep);
        $error.addClass("is-hidden");
      }
    } else {
      $error.removeClass("is-hidden");
    }
  });

  $form.on(
    "click",
    ".form-default__prev-next .cta-border-primary",
    function () {
      if (currentStep > 1) {
        currentStep--;
        showStep(currentStep);
      }
    },
  );

  //===== Restitution =====

  function showResults() {
    const cardsData = formatResult(formData);

    for (const [key, value] of Object.entries(cardsData)) {
      $(`[data-${key}]`).html(value);
    }

    // Calculer l'allocation
    const profil = formData.get("profil");
    const patrimony = PATRIMONY_STEPS[parseInt(formData.get("patrimony"), 10)];
    const hasRetirement = formData.getAll("objectives").includes("retirement");
    const knowledge = formData.get("knowledge");

    const allocation = getAllocation(profil, hasRetirement, patrimony);

    // Calculer les montants par enveloppe
    const envelopes = calculateAmountByEnvelopes(patrimony, allocation);

    let assets = {
      action: 0,
      obligation: 0,
      immobilier: 0,
      fondsEuros: 0,
      diversification: 0,
    };

    const assetsDistribution = {};
    const tbodyHTML = makeTable(envelopes, assets, assetsDistribution);
    const distributionByEnvelop = calcDistributionWithoutSaving(envelopes);
    const distributionByAsset = calcDistributionByAsset(assetsDistribution);

    createDonutChart(
      "#enveloppe",
      distributionByEnvelop.legend,
      distributionByEnvelop.distrib,
      COLORS,
    );

    createDonutChart(
      "#actif",
      distributionByAsset.map((elem) => {
        let [key, _val] = elem;
        return LABELS_ASSET[key];
      }),
      distributionByAsset.map((elem) => {
        let [_key, val] = elem;
        return val;
      }),

      COLORS,
    );

    // Obtenir les modes de gestion
    const management =
      MyProposalManagementMethods[knowledge] ||
      MyProposalManagementMethods.intermediaire;

    for (const [key, value] of Object.entries(management)) {
      $(`[data-${key}]`).html(value);
    }

    $form
      .find(".graph-recommandation__stroke")[0]
      .style.setProperty("--increase", `${management.mandat}%`);

    $form
      .find(".graph-recommandation__number span")[0]
      .style.setProperty("--num", management.mandat);

    $form.find("#allocation tbody").html("").append(tbodyHTML.join(""));
  }

  $(".form-default__prev-next").on(
    "click",
    ".cta-secondary, .cta-border-primary",
    function (e) {
      e.preventDefault();

      const headerHeight = $("header").outerHeight();

      if ($stepper.length) {
        $("html, body").animate(
          {
            scrollTop: $stepper.offset().top - headerHeight - 24,
          },
          350,

          function () {
            // Focus accessibilité
            $stepper.attr("tabindex", "-1").focus();
          },
        );
      }
    },
  );
});
